import { render, staticRenderFns } from "./RealizarVenda.vue?vue&type=template&id=6e5e4702&"
import script from "./RealizarVenda.vue?vue&type=script&lang=js&"
export * from "./RealizarVenda.vue?vue&type=script&lang=js&"
import style0 from "./RealizarVenda.vue?vue&type=style&index=0&id=6e5e4702&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports